function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M438.154,83.692H73.846C33.127,83.692,0,116.82,0,157.538v196.923c0,40.719,33.127,73.846,73.846,73.846h364.308 c40.719,0,73.846-33.127,73.846-73.846V157.538C512,116.82,478.873,83.692,438.154,83.692z M482.462,354.462 c0,24.431-19.876,44.308-44.308,44.308H73.846c-24.431,0-44.308-19.876-44.308-44.308V157.538 c0-24.431,19.876-44.308,44.308-44.308h364.308c24.431,0,44.308,19.876,44.308,44.308V354.462z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M373.169,303.262l-43.323-32.492h4.923c24.431,0,44.308-19.876,44.308-44.308s-19.876-44.308-44.308-44.308h-68.923 c-5.595,0-10.709,3.161-13.21,8.164l-45.867,91.734l-45.867-91.734c-3.647-7.296-12.518-10.256-19.814-6.605 c-7.296,3.647-10.253,12.519-6.605,19.814l59.077,118.154c2.501,5.004,7.615,8.164,13.21,8.164s10.709-3.161,13.211-8.164 l54.995-109.989h59.795c8.144,0,14.769,6.625,14.769,14.769s-6.625,14.769-14.769,14.769h-49.231c-6.357,0-12,4.068-14.011,10.099 c-2.01,6.031,0.064,12.671,5.15,16.485l78.769,59.077c2.656,1.992,5.766,2.955,8.85,2.955c4.491,0,8.927-2.04,11.827-5.909 C381.018,317.413,379.694,308.156,373.169,303.262z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var SvgVirtual = function SvgVirtual(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVirtual, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/virtual.8ddad9d7.svg";
export { ForwardRef as ReactComponent };